import { useAction, useAtom } from '@reatom/npm-react'
import styled, { css } from 'styled-components'

import { mediaMaxMobile } from '@root/shared/ui-kit'

import { TradingControlsLimitPercentage } from '../trading-controls-limit-slider'
import { TradingInputTarget } from '../trading-input-target'

import type { BuyControlsModel } from '@root/features/trade/trading-controls/atoms/common'

type Props = {
  model: BuyControlsModel
}

export const TradingControlsBuyLimit: React.FC<Props> = ({ model }) => {
  const {
    targetTypeAtom,
    targetPriceUsdAtom,
    targetMarketCapUsdAtom,
    setTargetTypeAction,
    setTargetRawValueAction,
    setPercentageAction,
    percentageAtom,
  } = model.limitModel

  const [percentage] = useAtom(percentageAtom)

  const [targetType] = useAtom(targetTypeAtom)
  const [targetPriceRaw] = useAtom(targetPriceUsdAtom.raw)
  const [targetMarketCapRaw] = useAtom(targetMarketCapUsdAtom.raw)

  const setPercentage = useAction(setPercentageAction)
  const setTargetRawValue = useAction(setTargetRawValueAction)
  const setTargetType = useAction(setTargetTypeAction)

  return (
    <Root>
      <TradingInputTarget
        value={
          targetType === 'market-cap' ? targetMarketCapRaw : targetPriceRaw
        }
        targetType={targetType}
        suffix={<CharIcon>$</CharIcon>}
        onChange={(e) => {
          setTargetRawValue(e.target.value)
        }}
        onChangeTargetType={(value) => {
          setTargetType(value)
        }}
      />

      <TradingControlsLimitPercentage
        type="buy"
        percentage={percentage}
        onPercentageChange={setPercentage}
      />
    </Root>
  )
}

const Root = styled.div`
  background: var(--appearanceA-2);

  display: grid;

  gap: 8px;
  overflow: hidden;
  align-items: center;

  padding: 12px 10px 30px;
  margin-top: 10px;
  gap: 10px;

  ${mediaMaxMobile(css`
    padding-bottom: 12px;
  `)}
`

const CharIcon = styled.div`
  color: var(--text-11);
  text-align: right;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
`
